import { useTokenMetadata } from "@/src/hooks/useTokenMetadata";
import { useDetailsViewedPageViewAnalytics } from "@/libs/analytics/analyticsHooks";
import { TabProps } from "../../types";
import TokenProperties from "./components/TokenProperties";
import AlchemyData from "./components/AlchemyData";
import { useTokenAttributeRarity } from "@/src/routes/collections/routes/[collectionName]/routes/products/routes/[productName]/routes/tokens/routes/[tokenId]/hooks";
import { FormattedTokenAttributeRarity } from "@/src/routes/collections/routes/[collectionName]/routes/products/routes/[productName]/routes/tokens/routes/[tokenId]/types";
import QueryLoadingWrapper from "@/src/components/QueryLoadingWrapper";
import { TokenMetadataType } from "@/src/types";

const DetailsTab = ({ productName, tokenId, collectionName }: TabProps) => {
  useDetailsViewedPageViewAnalytics();
  const { data, isLoading } = useTokenAttributeRarity(
    tokenId as string,
    collectionName,
  );
  const { data: tokenMetadata, isLoading: isTokenDataLoading } =
    useTokenMetadata(
      tokenId as string,
      collectionName as string,
      productName as string,
    );
  const attributes = tokenMetadata?.attributes;
  return (
    <div className="flex desktop:justify-between desktop:gap-16 flex-col desktop:flex-row w-full">
      {tokenId && (
        <div className="desktop:basis-1/2">
          <QueryLoadingWrapper isLoading={isTokenDataLoading || isLoading}>
            {attributes && tokenId && !isLoading && (
              <TokenProperties
                tokenRarityData={data as FormattedTokenAttributeRarity}
                attributes={attributes}
                tokenId={tokenId}
                collectionSlug={collectionName}
              />
            )}
          </QueryLoadingWrapper>
        </div>
      )}
      <AlchemyData
        productName={productName}
        tokenMetadata={tokenMetadata as TokenMetadataType}
        className={"flex-auto"}
      />
    </div>
  );
};

export default DetailsTab;
